import React, {useState} from 'react';
import block from 'bem-cn-lite';
import {Button, Text, Tooltip} from '@gravity-ui/uikit';
import {Envelope, Handset, MapPin} from '@gravity-ui/icons';
import {Link} from 'react-router-dom';
import {useMediaQuery} from 'react-responsive';

import './FooterBlock.scss';

const b = block('footer-block');

interface ContactProps {
    children: React.ReactNode;
    copyText: string;
}

interface FooterBlockProps {
    isMinimal?: boolean;
}

const Contact: React.FC<ContactProps> = ({children, copyText}) => {
    const [openTooltip, setOpenTooltip] = useState(false);

    return (
        <Tooltip
            content="Скопировано"
            placement="top-end"
            disabled={!openTooltip}
            openDelay={0}
            contentClassName={b('tooltip')}
            className={b('tooltip-container')}
        >
            <div
                className={b('copy')}
                onClick={() => {
                    setOpenTooltip(true);
                    navigator.clipboard.writeText(copyText);
                    setTimeout(() => setOpenTooltip(false), 1000);
                }}
            >
                {children}
            </div>
        </Tooltip>
    );
};

export const FooterBlock: React.FC<FooterBlockProps> = ({isMinimal = false}) => {
    const currentYear = new Date().getFullYear();
    const isSmallScreen = useMediaQuery({query: '(max-width: 1150px)'});

    if (isMinimal) {
        return (
            <div className={b('footer-minimal')}>
                <Text variant="subheader-2">ООО «Авто-Транзит»</Text>
                <div className={b('links')}>
                    <Link to="/profile/condition-refund" className={b('link')}>
                        <Text variant="body-1">Условия возврата</Text>
                    </Link>

                    <a
                        href="https://disk.yandex.ru/i/GwmTXHnpkl9zxA"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={b('link')}
                    >
                        <Text variant="body-1">Политика конфиденциальности</Text>
                    </a>
                </div>
                <Text variant="subheader-2">© {currentYear}</Text>
            </div>
        );
    }

    return (
        <footer className={b('container')}>
            <div className={b('column-1')}>
                <Text variant="subheader-2">ООО «Авто-Транзит»</Text>
                <Text variant="body-short">ИНН 5405042569</Text>
                <Text variant="body-short">ОГРН 1195476041892</Text>
            </div>
            <div className={b('block-contact')}>
                <div className={b('column-2')}>
                    <Text variant="subheader-2">Связаться с нами:</Text>
                    <Button view="flat" size="m">
                        <Handset className={b('icon')} />
                        <Contact copyText="+7 (383) 375-16-62">+7 (383) 375-16-62</Contact>
                    </Button>
                    <Button view="flat" size="m">
                        <Handset className={b('icon', 'icon-hidden')} />
                        <Contact copyText="+7 (383) 375-16-64">+7 (383) 375-16-64</Contact>
                    </Button>
                </div>
                <div className={b('column-3')}>
                    <Button view="flat" size="m">
                        <Envelope className={b('icon')} />
                        <Contact copyText="avtoem@zapnsk.ru">avtoem@zapnsk.ru</Contact>
                    </Button>
                    <Button view="flat" size="m">
                        <MapPin className={b('icon')} />
                        <Contact copyText="Новосибирск, ул. Оловозаводская, 47">
                            {isSmallScreen ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'flex-start'
                                    }}
                                >
                                    <Text variant="body-1">Новосибирск,</Text>
                                    <Text variant="body-1">ул. Оловозаводская, 47</Text>
                                </div>
                            ) : (
                                'Новосибирск, ул. Оловозаводская, 47'
                            )}
                        </Contact>
                    </Button>
                </div>
            </div>
        </footer>
    );
};
